import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapThumb } from './ui';

/* The /maps list returns { map, mode, total_battles, event_id }. The event id
   matches the map art in public/media/maps; MapThumb falls back to a
   placeholder when no image is committed. Top picks live on the detail page. */
function MapCard({ m }) {
  const navigate = useNavigate();
  return (
    <div className="map-card" onClick={() => navigate(`/maps/${encodeURIComponent(m.map)}`)}>
      <MapThumb id={m.event_id} mode={m.mode} variant="thumb" />
      <div className="mc-body">
        <div className="mc-mode">{m.mode}</div>
        <div className="mc-name">{m.map}</div>
        <div className="mc-foot">
          <span>🗺</span>
          {(m.total_battles ?? 0).toLocaleString()} battles tracked
        </div>
      </div>
    </div>
  );
}

export default MapCard;
